import { render, staticRenderFns } from "./GenericLoader.vue?vue&type=template&id=64a15a47"
import script from "./GenericLoader.vue?vue&type=script&lang=js"
export * from "./GenericLoader.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports